const routes = [
  {
    index: true,
    label: 'Yonatan Bebchuk',
    path: '/',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Reading',
    path: '/reading',
  },
  {
    label: 'Writings',
    path: '/writings',
  },
];

export default routes;
